const styles = ({ COLORS, BREAKPOINTS }) => ({
  container: {
    paddingTop: '10px',
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  },
  content: {
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      width: '48%'
    }
  },
  intro: {
    fontSize: '16px',
    lineHeight: '20px'
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: '100%'
  },
  title: {
    fontSize: '22px',
    lineHeight: '24px',
    margin: '18px 0 0'
  },
  label: {
    color: '#666',
    '& svg': {
      marginTop: '-3px'
    }
  },
  event: {
    marginBottom: '50px'
  },
  eventButton: {
    marginTop: '15px'
  },
  line: {
    border: 'none',
    height: '1px',
    background: '#ddd',
    marginBottom: '40px'
  },
  moderator: {
    textAlign: 'center',
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      width: '50%',
      display: 'flex',
      alignItems: 'center'
    },
    '& img': {
      maxWidth: '240px',
      borderRadius: '100%'
    },
    '& a': {
      display: 'block',
      transition: '300ms ease-in-out'
    },
    '& a:hover': {
      opacity: 0.7
    },
    '& p': {
      maxWidth: '60%',
      margin: '20px auto'
    }
  }
})

export default styles
